<template>
  <div>
    <a-lazy-hydrate when-visible>
      <a-breadcrumbs />
    </a-lazy-hydrate>

    <a-lazy-hydrate
      v-if="mostViewedArticles.length"
      when-visible
      :key="
        $_lazyHydratedComponentState_getHydratedComponentRefreshKey(
          $options.consts.HYDRATED_SECTION_NAME.MOST_VIEWED
        )
      "
    >
      <a-visibility hide :on="[$breakpoint.mobile]">
        <a-most-viewed
          :articles="mostViewedArticles"
          class="tag__most-viewed"
          @mounted="
            $_lazyHydratedComponentState_onHydratedComponentMounted(
              $options.consts.HYDRATED_SECTION_NAME.MOST_VIEWED
            )
          "
        />
      </a-visibility>
    </a-lazy-hydrate>

    <nuxt-child />
  </div>
</template>

<script>
import mixins from '@/utils/mixins'
import AMostViewed from 'shared/AMostViewed'
import ABreadcrumbs from 'shared/ABreadcrumbs'
import { MOST_VIEWED_ARTICLES_MODEL } from '@/utils/enums/responseModels'
import { applyFallback } from '@/utils/helpers'

const HYDRATED_SECTION_NAME = {
  MOST_VIEWED: 'MOST_VIEWED'
}

async function getTagPageData({ ctx, store }) {
  const { dispatch } = store

  const { mostViewedArticles } = await dispatch(
    'articles/requestMostViewedArticles',
    {
      isSponsored: false
    }
  )

  return {
    mostViewedArticles: applyFallback(
      mostViewedArticles,
      MOST_VIEWED_ARTICLES_MODEL
    )
  }
}

export default {
  name: 'TagPage',
  components: { ABreadcrumbs, AMostViewed },
  mixins: [
    mixins.setPageLoaded,
    mixins.delayedContentRefresh,
    mixins.lazyHydratedComponentState
  ],
  consts: {
    HYDRATED_SECTION_NAME
  },
  async asyncData(ctx) {
    try {
      /**
       * We do not handle canonical URL on this page because it is already
       * handled on children pages
       */
      const { mostViewedArticles } = await getTagPageData({
        ctx,
        store: ctx.store
      })

      return {
        mostViewedArticles
      }
    } catch (err) {
      ctx.app.$errorHandler(err, ctx)
    }
  },
  data() {
    return {
      mostViewedArticles: null
    }
  },
  mounted() {
    this.$_delayedContentRefresh_run({
      getOldDataFn: () => this.mostViewedArticles,
      requestNewDataFn: async () => {
        const { mostViewedArticles } = await getTagPageData({
          ctx: this,
          store: this.$store
        })

        return mostViewedArticles
      },
      dataChangedCallbackFn: mostViewedArticles => {
        this.mostViewedArticles = mostViewedArticles
        this.$_lazyHydratedComponentState_rerenderNonHydratedComponents(
          Object.values(HYDRATED_SECTION_NAME)
        )
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.tag__most-viewed {
  margin-top: 5px;
}
</style>
